// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"8d2d7bb3","218":"ce60600e","453":"4a870e46","477":"6f7202f9","682":"04b06cd2","691":"c74c57db","765":"7fa10b91","867":"4970b200","948":"28640db2","972":"9cc415e5","988":"88ab958e"}[chunkId] + ".chunk.js";
};